import { gql } from '@apollo/client';

export default gql`
  query accountCreditCards {
    accountCreditCards {
      id
      nameOnCard
      maskedNumber
      brand
      defaultCard
      expiryMonth
      expiryYear
      billingAddress
      createdAt
      updatedAt
    }
  }
`;
